import { Select } from "antd";
import { FC } from "react";

const SelectUnitField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="toman" >تومان</Select.Option>
      <Select.Option key="coin" >سکه</Select.Option>
    </Select>
  )
}

export default SelectUnitField
